import ms from 'ms'

/**
 * Simulate the delay of a promise and execution
 * @param delayValue -the ms string delay value
 */
export function sleep(delayValue: string): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms(delayValue)))
}
